import { MsalService } from '@azure/msal-angular';
import { TokenAdmService } from './../../services/token-adm.service';
import { TemaService } from './../../services/tema.service';
import { PreguntaService } from '../../services/pregunta.service';
import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import {Location} from '@angular/common';
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.css']
})

export class PreguntasComponent implements OnInit {
  preguntas:any= [];
  temaId:number;
  ruta: string;
  tema:string;
  burbuja:string;
  loadingPreguntas:boolean=false;
  loadingValores:boolean=false;
  burbujaId:string;
  objBurbujaTema:any;
  isAdmin:boolean;
  isContribuidor:boolean;
  editar:boolean=true;
  ordenar:boolean=false;
  preguntasTempo:any;


  constructor(private activatedRoute:ActivatedRoute, private preguntaService:PreguntaService, private router:Router,
    private location:Location, private temaService:TemaService, private tokenService:TokenAdmService,
    private authService:MsalService ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params =>{
      this.temaId = params['temaId'];
       })
    this.loadingPreguntas = true;

    let preguntasPrivadas:boolean;
    this.preguntaService.getPrivacidadPreguntasByTema(this.temaId).subscribe(
     (resp:boolean) =>{
       preguntasPrivadas = resp;
       if(preguntasPrivadas==true){
        sessionStorage.setItem('privado','SI')
        let sesionIniciada =this.tokenService.verificaUsuario()
        if (!sesionIniciada){
          this.authService.loginRedirect()
          this.ruta = 'help/preguntas/'+ this.temaId;
          this.router.navigateByUrl(this.ruta)
        }
        else {
          this.cargarInicio();
        }
      }
      else {this.cargarInicio()}
    },
    error => {
      console.error(error);
      this.loadingPreguntas = false;
    }
    )
    sessionStorage.setItem('returnPreguntas',this.router.url)
  }

  cargarInicio(){
    this.preguntaService.getActivasByTemaPublic(this.temaId).subscribe(
      resp => {
        this.preguntas = resp;
        this.loadingPreguntas = false;
      },
      error => {
        console.error(error);
        this.loadingPreguntas = false;
      })
     this.cargarValores(this.temaId);
     this.isAdmin = this.tokenService.hasRole('Help_Admin')
     this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor')
  }



  responderPregunta(id:number)
  {
    this.ruta = 'help/respuesta/'+id;
    this.router.navigateByUrl(this.ruta);
  }


  cargarValores(temaId:number){
    this.loadingValores = true;
    this.temaService.getTemaBurbujaByTemaPublic(temaId).subscribe(
      resp => {
        if (resp!==null)
        {
          this.objBurbujaTema = resp;
          this.burbujaId = this.objBurbujaTema.burbujaId;
          this.burbuja = this.objBurbujaTema.burbujaDescripcion;
          this.tema = this.objBurbujaTema.temaDescripcion;
        }
        this.loadingValores = false;
        },
      error => {
        console.error(error);
        this.loadingValores = false;
      }
     )

  }

  habilitarOrdenar(){
    this.ordenar=true;
    this.editar=false;
    this.preguntasTempo = JSON.parse(JSON.stringify(this.preguntas));;
  }

  cancelarOrdenar(){
    this.ordenar = false;
    this.editar=true;
    this.preguntas = this.preguntasTempo;
  }

  guardarOrdenamiento(){
    Swal.fire({
      title: 'Confirmación',
      html: '¿Confirmas que queres guardar los cambios en el ordenamiento que hiciste?',
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
        });
        Swal.showLoading();
        let timerInterval
        this.preguntaService.cambiarOrden(this.preguntas)
        .subscribe({
          next: resp => {
          Swal.fire({
            title: 'Cambios guardados correctamente',
            text: 'El ordenamiento ha sido guardado correctamente en la base de datos',
            icon: 'success',
            timer: 1500,
            timerProgressBar: true,
            willClose: () => {
              clearInterval(timerInterval)
              this.ordenar = false;
              this.editar=true;
            },
            didOpen: () => {
              Swal.showLoading()
              const b = Swal.getHtmlContainer().querySelector('b')
              timerInterval = setInterval(() => {
                if (b){
                  b.textContent = Swal.getTimerLeft()?.toString()
                }
              }, 100)
            }
          }).then(resp => {
            if (resp.isConfirmed) {
             this.ordenar = false;
             this.editar=true;
          }})
        },
        error: error => {
          console.error(error.error);
          Swal.fire({
            title: 'No se pudo actualizar el ordenamiento',
            text: 'Ocurrió un error al intentar actualizar en la base de datos el ordenamiento',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      })
     }
    })
  }



  nuevaPregunta(temaId:number){
    sessionStorage.setItem('origenPregunta',location.pathname)
    this.ruta = 'help/pregunta/0/'+temaId;
    this.router.navigateByUrl(this.ruta);
  }

  editarPregunta(preguntaId:number){
    sessionStorage.setItem('origenPregunta',location.pathname)
    this.ruta = 'help/pregunta/'+preguntaId;
    this.router.navigateByUrl(this.ruta);
  }


  borrarPregunta(preguntaId:number, enunciado:string) {
    Swal.fire({
      title: 'Eliminar pregunta',
      html: `¿Estas seguro que deseas eliminar esta pregunta?<br>${enunciado}`,
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
         });
         let timerInterval
          Swal.showLoading();
            this.preguntaService.eliminarPregunta(preguntaId)
            .subscribe({
              next: data => {
                Swal.fire({
                //  title: 'Pregunta eliminada correctamente',
                  text: `Pregunta eliminada correctamente`,
                  icon: 'success',
                  timer: 1500,
                  timerProgressBar: true,
                  willClose: () => {
                    clearInterval(timerInterval)
                    this.reload();
                  },
                  didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      if (b){
                        b.textContent = Swal.getTimerLeft()?.toString()
                      }
                    }, 100)
                  }
                }).then(resp => {
                  if (resp.isConfirmed) {
                      //sessionStorage.setItem('origen','respuesta')
                      //sessionStorage.setItem('indexTema',indexTema.toString())
                      this.reload();
                  }})
              },
              error: error => {
                console.error(error.error);
                Swal.fire({
                  title: 'No se pudo eliminar la pregunta',
                  text: `Ocurrió un error al eliminar la pregunta ${enunciado}`,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
          });
        }

      })
  }

  reload(){
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation="reload"
    this.router.navigate([this.router.url])
  }

  gotoTemas(burbujaId:string)
  {
    this.ruta = 'help/temas/'+burbujaId;
    this.router.navigateByUrl(this.ruta);
  }

  drop(evento: CdkDragDrop<any> ) {
    moveItemInArray( this.preguntas, evento.previousIndex, evento.currentIndex );
    evento.container.data.forEach((x,index)=>{
      x.orden=index
    })
  }

  volver() {
    this.router.navigateByUrl( sessionStorage.getItem('returnTemas'));
  }

}
